import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import { Link } from 'react-router-dom';
import { translate } from 'admin-on-rest';
import { stringify } from 'query-string';

import BranchIcon from 'material-ui/svg-icons/action/extension';

const LinkToRelatedProducts = ({ record, translate }) => (
    <FlatButton
        primary
        label= {translate('resources.branches.name')}
        icon={<BranchIcon />}
        containerElement={<Link
            to={{
                pathname: 'branches',
                search: stringify({ page: 1, perPage: 10, filter: JSON.stringify({ motherCompany: record.id }) }),
            }}
        />}
    />
);

export default translate(LinkToRelatedProducts);



// WEBPACK FOOTER //
// ./src/pages/companies/LinkToRelatedProducts.js